// extracted by mini-css-extract-plugin
export default {"block":"ui_block__hDmF+"};